module.exports = __webpack_public_path__ + "static/i4-a36991dcaf9d29bd25ba4b809909d4d2.jpg";